<ng-container *ngIf="!useChoosePlan; else choosePlanBtn">
  <!-- Plan Action Buttons (when not using choose plan button) -->
  <div class="choose-plan-buttons">
    <ng-container [ngSwitch]="determinePlanState()">
      <!-- Current Plan -->
      <button
        mat-raised-button disabled
        *ngSwitchCase="'current'"
        class="btn btn-current-plan"
        disabled>
        <ng-container *ngIf="isV2; else fullCurrentPlanText">
          {{ 'billing.currentPlan' | translate | uppercase | slice:0:7 }}
        </ng-container>
        <ng-template #fullCurrentPlanText>
          {{ 'billing.currentPlan' | translate | uppercase }}
        </ng-template>
      </button>

      <!-- Future Plan -->
      <button
        mat-raised-button disabled
        *ngSwitchCase="'future'"
        class="btn btn-future-plan"
        disabled>
        {{ 'billing.starts' | translate: { date: nextPaymentDateFormatted } }}
      </button>

      <!-- Upgrade -->
      <button
        *ngSwitchCase="'upgrade'"
        mat-raised-button
        [color]="!isV2 ? 'primary' : 'accent'"
        class="btn btn-upgrade"
        (click)="handlePlanCardBtnClick()"
        [trackClick]="getTrackingData('upgrade')">
        <ng-container *ngIf="isV2; else fullUpgradePlanText">
          {{ 'billing.upgradePlan' | translate | uppercase | slice:0:7 }}
        </ng-container>
        <ng-template #fullUpgradePlanText>
          {{ 'billing.upgradePlan' | translate | uppercase }}
        </ng-template>
      </button>

      <!-- Downgrade -->
      <button
        *ngSwitchCase="'downgrade'"
        mat-stroked-button
        [color]="!isV2 ? 'primary' : 'accent'"
        class="btn btn-downgrade"
        (click)="handlePlanCardBtnClick()"
        [trackClick]="getTrackingData('downgrade')">
        <ng-container *ngIf="isV2; else fullDowngradePlanText">
          {{ 'billing.downgradePlan' | translate | uppercase | slice:0:10 }}
        </ng-container>
        <ng-template #fullDowngradePlanText>
          {{ 'billing.downgradePlan' | translate | uppercase }}
        </ng-template>
      </button>
    </ng-container>
  </div>
</ng-container>

<ng-template #choosePlanBtn>
  <button
    mat-raised-button
    [color]="!isV2 ? 'primary' : 'accent'"
    class="btn change-plan-button"
    (click)="handlePlanCardBtnClick()"
    [trackClick]="getChoosePlanTrackData()"
  >
    {{ 'billing.choosePlanBtn' | translate | uppercase }}
  </button>
</ng-template>
